import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DirectAddAssetsComponent } from '@app/modules/direct/components/direct-add-assets/direct-add-assets.component';
import { DirectAddPropertiesComponent } from '@app/modules/direct/components/direct-add-properties/direct-add-properties.component';
import { DirectAddSelectTypeComponent } from '@app/modules/direct/components/direct-add-select-type/direct-add-select-type.component';
import { DirectAddSubdomainComponent } from '@app/modules/direct/components/direct-add-subdomain/direct-add-subdomain.component';
import { DirectAddTemplateComponent } from '@app/modules/direct/components/direct-add-template/direct-add-template.component';
import { DirectBookingPolicyTermEditorComponent } from '@app/modules/direct/components/direct-booking-policy-term-editor/direct-booking-policy-term-editor.component';
import { DirectEditInsightsComponent } from '@app/modules/direct/components/direct-edit-insights/direct-edit-insights.component';
import { DirectEditMarketingComponent } from '@app/modules/direct/components/direct-edit-marketing/direct-edit-marketing.component';
import { DirectEditSiteHeaderComponent } from '@app/modules/direct/components/direct-edit-site-header/direct-edit-site-header.component';
import { DirectFooterFormComponent } from '@app/modules/direct/components/direct-footer-form/direct-footer-form.component';
import { DirectHeroFormComponent } from '@app/modules/direct/components/direct-hero-form/direct-hero-form.component';
import { DirectOverviewSetupGuideComponent } from '@app/modules/direct/components/direct-overview-setup-guide/direct-overview-setup-guide.component';
import { DirectSiteTypeCardComponent } from '@app/modules/direct/components/direct-site-type-card/direct-site-type-card.component';
import { DirectSitesListComponent } from '@app/modules/direct/components/direct-sites-list/direct-sites-list.component';
import { DirectSocialFormComponent } from '@app/modules/direct/components/direct-social-form/direct-social-form.component';
import { DirectSubnavModule } from '@app/modules/direct/components/direct-subnav/direct-subnav.module';
import { DirectTemplateLightComponent } from '@app/modules/direct/components/direct-template-light/direct-template-light.component';
import { DialogDeleteSiteComponent } from '@app/modules/direct/dialogs/dialog-delete-site/dialog-delete-site.component';
import { DialogPublishSiteComponent } from '@app/modules/direct/dialogs/dialog-publish-site/dialog-publish-site.component';
import { DialogRenameSiteComponent } from '@app/modules/direct/dialogs/dialog-rename-site/dialog-rename-site.component';
import { DialogSiteCreatedComponent } from '@app/modules/direct/dialogs/dialog-site-created/dialog-site-created.component';
import { DialogUnpublishSiteComponent } from '@app/modules/direct/dialogs/dialog-unpublish-site/dialog-unpublish-site.component';
import { DirectPayoutMethodsGetKYCLinkComponent } from '@app/modules/direct/pages/direct-payout-methods-get-kyc-link/direct-payout-methods-get-kyc-link.component';
import { DirectPayoutsMethodsAddTaxInformationComponent } from '@app/modules/direct/pages/direct-payouts-methods-add-tax-information/direct-payouts-methods-add-tax-information';
import { SharedModule } from '@app/shared/shared.module';
import { DefaultPayoutMethodOptionComponent } from './components/default-payout-method-option/default-payout-method-option.component';
import { DialogDirectAddDomainComponent } from './components/dialog-direct-add-domain/dialog-direct-add-domain.component';
import { DialogWidgetPreviewComponent } from './components/dialog-widget-preview/dialog-widget-preview.component';
import { DirectEditDomainsComponent } from './components/direct-edit-domains/direct-edit-domains.component';
import { DirectEditMpsWidgetComponent } from './components/direct-edit-mps-widget/direct-edit-mps-widget.component';
import { DirectEditOverviewComponent } from './components/direct-edit-overview/direct-edit-overview.component';
import { DirectEditPropertiesComponent } from './components/direct-edit-properties/direct-edit-properties.component';
import { DialogEditLocationComponent } from './components/direct-location-editor/dialog-edit-location/dialog-edit-location.component';
import { DirectLocationEditorItemComponent } from './components/direct-location-editor/direct-location-editor-item/direct-location-editor-item.component';
import {
  DirectLocationEditorComponent,
  DragAndDropManagerDirective,
  DragAndDropManagerRootDirective,
} from './components/direct-location-editor/direct-location-editor.component';
import { DirectPayoutMethodStatusComponent } from './components/direct-payout-method-status/direct-payout-method-status.component';
import { DirectPlanGridItemComponent } from './components/direct-plan-grid-item/direct-plan-grid-item.component';
import { DirectPropertiesSelectionComponent } from './components/direct-properties-selection/direct-properties-selection.component';
import { PromoCodesEditCodesComponent } from './components/promo-codes-edit-codes/promo-codes-edit-codes.component';
import { PromoCodesEditRestrictionsComponent } from './components/promo-codes-edit-restrictions/promo-codes-edit-restrictions.component';
import { PropertyOverlapWarningComponent } from './components/property-overlap-warning/property-overlap-warning.component';
import { DialogCopyWidgetCodeComponent } from './dialogs/dialog-copy-widget-code/dialog-copy-widget-code.component';
import { DialogDirectCancelInterstitialComponent } from './dialogs/dialog-direct-cancel-interstitial/dialog-direct-cancel-interstitial.component';
import { DialogSubscribeToDirectComponent } from './dialogs/dialog-subscribe-to-direct/dialog-subscribe-to-direct.component';
import { DialogSwitchPlanInterstitialComponent } from './dialogs/dialog-switch-plan-interstitial/dialog-switch-plan-interstitial.component';
import { DialogUpdatePropertySlugComponent } from './dialogs/dialog-update-property-slug/dialog-update-property-slug.component';
import { DirectRoutingModule } from './direct-routing.module';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DirectAddComponent } from './pages/direct-add/direct-add.component';
import { DirectBookingPoliciesComponent } from './pages/direct-booking-policies/direct-booking-policies.component';
import { DirectChannelsListComponent } from './pages/direct-channels-list/direct-channels-list.component';
import { DirectCustomSiteEditComponent } from './pages/direct-custom-site-edit/direct-custom-site-edit.component';
import { DirectEditBookingPolicyComponent } from './pages/direct-edit-booking-policy/direct-edit-booking-policy.component';
import { DirectEditComponent } from './pages/direct-edit/direct-edit.component';
import { DirectInstantBookComponent } from './pages/direct-instant-book/direct-instant-book.component';
import { DirectPayoutHistoryComponent } from './pages/direct-payout-history/direct-payout-history.component';
import { DirectPayoutMethodsComponent } from './pages/direct-payout-methods-list/direct-payout-methods-list.component';
import { DirectPayoutsEditComponent } from './pages/direct-payouts-edit/direct-payouts-edit.component';
import { DirectPayoutsMethodsAddAdyenComponent } from './pages/direct-payouts-methods-add-adyen/direct-payouts-methods-add-adyen.component';
import { DirectPayoutsMethodsAddStripeComponent } from './pages/direct-payouts-methods-add-stripe/direct-payouts-methods-add-stripe';
import { DirectPayoutsStripeOauthSuccessComponent } from './pages/direct-payouts-stripe-oauth-success/direct-payouts-stripe-oauth-success.component';
import { DirectPromoCodesAddComponent } from './pages/direct-promo-codes-add/direct-promo-codes-add.component';
import { DirectPromoCodesEditComponent } from './pages/direct-promo-codes-edit/direct-promo-codes-edit.component';
import { DirectPromoCodesComponent } from './pages/direct-promo-codes/direct-promo-codes.component';
import { DirectSubscriptionComponent } from './pages/direct-subscription/direct-subscription.component';
import { DirectTrialComponent } from './pages/direct-trial/direct-trial.component';
import { DirectWidgetAddComponent } from './pages/direct-widget-add/direct-widget-add.component';

import { DirectDomainDescriptionComponent } from '@app/modules/direct/components/direct-domain-description/direct-domain-description.component';
import { EarningsReportsComponent } from './pages/earnings-reports/earnings-reports.component';
import { CancellationTermsByTypePipe } from './pipes/cancellation-terms-by-type.pipe';
import { ChannelsSiteIdToUrlPipe } from './pipes/channels-site-id-to-url.pipe';
import { DirectSubscriptionDescriptionFromKeyPipe } from './pipes/directSubscriptionDescriptionFromKey/direct-subscription-description-from-key.pipe';
import { FriendlyPublishStatusPipe } from './pipes/friendlyPublishStatus/friendly-publish-status.pipe';
import { GetDomainPipe } from './pipes/get-domain.pipe';
import { GetPropertyUrlPipe } from './pipes/get-property-url.pipe';
import { IgnorePropertyChecksPipe } from './pipes/ignore-property-checks.pipe';
import { IsPropertyGVREligiblePipe } from './pipes/is-property-gvreligible.pipe';
import { PayoutMethodSubtitlePipe } from './pipes/payout-method-subtitle.pipe';
import { PayoutMethodTitlePipe } from './pipes/payout-method-title.pipe';
import { PropertyHasBlockCheckPipe } from './pipes/property-has-block-check.pipe';

// Imports for DirectEditDomainsComponent template
import { ClipboardModule } from '@angular/cdk/clipboard';

@NgModule({
  declarations: [
    DashboardComponent,
    DirectSitesListComponent,
    DirectOverviewSetupGuideComponent,
    DirectEditComponent,
    DirectEditSiteHeaderComponent,
    DirectAddComponent,
    DirectAddSelectTypeComponent,
    DirectAddSubdomainComponent,
    DirectAddPropertiesComponent,
    DirectAddTemplateComponent,
    DirectAddAssetsComponent,
    DirectSiteTypeCardComponent,
    DirectEditPropertiesComponent,
    DirectEditDomainsComponent,
    DirectEditOverviewComponent,
    DirectHeroFormComponent,
    DirectFooterFormComponent,
    DirectSocialFormComponent,
    DirectEditMarketingComponent,
    DirectEditInsightsComponent,
    FriendlyPublishStatusPipe,
    DirectSubscriptionDescriptionFromKeyPipe,
    DialogDirectAddDomainComponent,
    DirectPlanGridItemComponent,
    DirectTrialComponent,
    DirectSubscriptionComponent,
    DirectPayoutMethodsComponent,
    DirectPayoutsMethodsAddStripeComponent,
    DirectPayoutsEditComponent,
    DirectPayoutsMethodsAddTaxInformationComponent,
    DirectPayoutsStripeOauthSuccessComponent,
    DirectPayoutHistoryComponent,
    DirectTemplateLightComponent,
    DirectPayoutsMethodsAddAdyenComponent,
    PayoutMethodTitlePipe,
    PayoutMethodSubtitlePipe,
    DirectPayoutMethodStatusComponent,
    PropertyOverlapWarningComponent,
    DefaultPayoutMethodOptionComponent,
    DialogSubscribeToDirectComponent,
    DialogSwitchPlanInterstitialComponent,
    DialogDirectCancelInterstitialComponent,
    DirectWidgetAddComponent,
    DirectPropertiesSelectionComponent,
    DialogWidgetPreviewComponent,
    DialogCopyWidgetCodeComponent,
    CancellationTermsByTypePipe,
    DirectChannelsListComponent,
    IsPropertyGVREligiblePipe,
    DirectInstantBookComponent,
    IgnorePropertyChecksPipe,
    DialogUpdatePropertySlugComponent,
    DirectPromoCodesComponent,
    ChannelsSiteIdToUrlPipe,
    DirectPromoCodesAddComponent,
    PromoCodesEditCodesComponent,
    PromoCodesEditRestrictionsComponent,
    DirectPromoCodesEditComponent,
    PropertyHasBlockCheckPipe,
    DirectEditMpsWidgetComponent,
    DirectLocationEditorComponent,
    DragAndDropManagerDirective,
    DragAndDropManagerRootDirective,
    DirectLocationEditorItemComponent,
    DialogEditLocationComponent,
    DirectCustomSiteEditComponent,
    GetPropertyUrlPipe,
    GetDomainPipe,
    DirectBookingPoliciesComponent,
    DirectEditBookingPolicyComponent,
    DirectBookingPolicyTermEditorComponent,
    EarningsReportsComponent,
    DirectPayoutMethodsGetKYCLinkComponent,
    DialogRenameSiteComponent,
    DialogDeleteSiteComponent,
    DialogUnpublishSiteComponent,
    DialogPublishSiteComponent,
    DialogSiteCreatedComponent,
    DirectDomainDescriptionComponent,
  ],
  imports: [
    CommonModule,
    DirectRoutingModule,
    SharedModule,
    GoogleMapsModule,
    DirectSubnavModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSnackBarModule,

    // Imports for DirectEditDomainsComponent template
    ClipboardModule,
  ],
})
export class DirectModule {}
